import * as config from '../config'
import Character from "../objects/character";
import Wall from "../objects/wall";
import {AlignGrid} from "../class/alignGrid";
import {Align} from "../class/align";
import {Bug} from "../objects/bug";
import {Code} from "../objects/code";
import Bar from "../objects/bar";
import Bullet from "../objects/bullet";
import helper from '../helpers'
import Deadline from "../objects/deadline";
import Manager from "../objects/manager";
import Coin from "../objects/coin";

export default class Game extends Phaser.Scene {

    constructor() {
        super({
            key: 'Game'
        });
    }

    create() {
        this.projectLine = 0;
        this.objectUpdate = [];
        this.aGrid = new AlignGrid({scene: this, rows: 15, cols: 15})
        this.background = window.background = this.add.image(0, 0, 'background');
        this.background.depth = -1;
        this.background.setDisplaySize(config.width, 950)
        Align.centerWidth(this.background)
        this.background.y = this.background.displayHeight/2
        this.createGroups();
        this.createModels();
        this.createInputs();
        this.createCollides();

        this.modelCharacter.gravity = 800;
    }

    createCollides() {
        this.physics.add.collider(this.character, this.groupWall);
        this.physics.add.collider(this.groupBug, this.groupWall);
        this.physics.add.collider(this.groupCode, this.groupWall);
        this.physics.add.collider(this.groupCoin, this.groupWall,
            (coin, wall) => {
            window.coin = coin;
                if (wall.wallType === 'down') {
                    this.time.delayedCall(2000, () => {
                        this.modelCoin.remove(coin)
                    })
                }
            });
        this.physics.add.collider(this.groupCode, this.groupBug);
        this.physics.add.collider(this.groupManager, this.groupWall);
        this.physics.add.overlap(this.character, this.groupBug,
            (character, bug) => {
                if (!bug.isHitted) {
                    this.modelBug.pickUp(bug.id, config.projectile.bug.value)
                    this.groupBug.remove(bug, true, true);
                }
            });
        this.physics.add.overlap(this.groupManager, this.groupBullet,
            (manager, bullet) => {
                helper.hit(manager.id, bullet, this.modelManager.dbManager, this, this.groupManager);
            });
        this.physics.add.overlap(this.character, this.groupCode,
            (character, code) => {
                this.modelCode.pickUp(code.id, config.projectile.code.value)
                this.groupCode.remove(code, true, true);
            });
        this.physics.add.overlap(this.groupBug, this.groupBullet,
            (bug, bullet) => {
                helper.hit(bug.id, bullet, this.modelBug.dbBug, this, this.groupBug);
            })
        this.physics.add.overlap(this.groupDeadline, this.character,
            () => {
                this.cameras.main.shake(500);
                this.time.delayedCall(500, () => {
                    helper.gameEnd(this, config)
                });
            })
        this.physics.add.collider(this.character, this.groupManager,
            (character ,manager) => {
                this.modelCharacter.setManagerEffect(manager)
            })
        this.physics.add.overlap(this.character, this.groupCoin,
            (character, coin) => {
                this.modelCharacter.setCoinEffect(coin)
            })
    }

    createGroups() {
        this.groupBug = this.physics.add.group();
        this.groupCode = this.physics.add.group();
        this.groupCoin = this.physics.add.group();
        this.groupWall = this.physics.add.group({
            immovable: true,
            allowGravity: false
        });
        this.groupBullet = this.physics.add.group()
        this.groupDeadline = this.physics.add.group()
        this.groupManager = this.physics.add.group();
    }

    createModels() {
        this.modelBar = new Bar({scene: this, grid: this.aGrid});
        this.modelBug = new Bug(this, this.groupBug);
        this.modelCode = new Code(this, this.groupCode);
        this.modelCoin = new Coin(this, this.groupCoin);
        this.modelCharacter = new Character(this, config.width / 2);
        this.modelManager = new Manager(this, this.groupManager);
        this.modelWall = new Wall(this, this.groupWall)
        this.modelBullet = new Bullet(this, this.groupBullet)
        this.modelDeadline = new Deadline(this, this.groupDeadline)
    }

    createInputs() {
        this.movementKeys = this.input.keyboard.addKeys({
            up: 'up',
            right: 'right',
            left: 'left',
        })
        this.input.on('pointerdown', () => {
            this.modelCharacter.kick()
        });

        this.input.keyboard.on('keydown-' + 'SPACE', () => {
            this.modelCharacter.kick()
        });

        this.movementKeys.up.on('down', () => {
            this.modelCharacter.jump();
        })
    }

    update(time, delta) {
        this.modelCharacter.navigation();
        this.modelBug.generateBug();
        this.modelCode.generateCode();
        this.modelCharacter.changeAnimation();
        this.modelBug.object.gravityChange();
        this.modelCode.object.gravityChange();
        this.modelCoin.generateCoin();
        this.modelDeadline.update();
        this.modelManager.generateManager();
        this.modelCharacter.negativeEffectsUpdate();
    }
}
